import { fetchAction } from 'src/redux/actions';
import urls from 'src/urls/profile';

import { FetchProfileRepositoriesLanguages } from './';

export const fetchProfileRepositoriesLanguages = (workspaceSlug: string) => {
  return fetchAction(FetchProfileRepositoriesLanguages, {
    url: urls.api.internal.repositoriesLanguages(workspaceSlug),
  });
};
